const groupsTypesMap = {
  0: 'Unsupervised',
  1: 'Supervised',
};

export default groupsTypesMap;
